import {
    faPaperPlane,
    faBasketShopping,
    faHome,
    faPrint,
    faShop,
    faTabletScreen,
} from "@fortawesome/pro-light-svg-icons"
import {
    SUPPORT_REPORTS_ENTITIES_ROUTE,
    SUPPORT_REPORTS_MESSAGES_EMAIL_ROUTE,
    SUPPORT_REPORTS_MESSAGES_ROUTE,
    SUPPORT_REPORTS_MESSAGES_SMS_ROUTE,
    SUPPORT_REPORTS_ROUTE,
    SUPPORT_REPORTS_ROUTE_DEVICES,
    SUPPORT_REPORTS_PRINTER_QUEUE,
    SUPPORT_REPORTS_ROUTE_ORDERS_ROUTE,
    SUPPORT_REPORTS_ROUTE_ORDERS_POS_ROUTE,
    SUPPORT_REPORTS_ROUTE_ORDERS_SUBSCRIPTIONS_ROUTE,
    SUPPORT_REPORTS_ROUTE_ORDERS_MEETING_SERVICE_ROUTE,
} from "../../../../constants/routes"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { NavMenuItem } from "../../../../shared/layouts/components/NavMenuItem"
import { NavMenuItemGroupWrapper, NavMenuSubItem } from "../../../../shared/layouts/components/NavMenuItemGroup"
import { MatchEnvironment } from "../../../environment/components/MatchEnvironment"
import { UNFINISHED_FEATURE_ENVIRONMENTS } from "../../../../shared/components/filters/constants/filterMenuConst"

export function SupportReportNavItems() {
    return (
        <>
            <LocalizedStrict id="support-nav-item-home">
                <NavMenuItem icon={faHome} dest={SUPPORT_REPORTS_ROUTE}>
                    Home
                </NavMenuItem>
            </LocalizedStrict>
            <LocalizedStrict id="support-nav-item-entities-access">
                <NavMenuItem icon={faShop} dest={SUPPORT_REPORTS_ENTITIES_ROUTE}>
                    Entities
                </NavMenuItem>
            </LocalizedStrict>
            {/*<LocalizedStrict id="support-nav-item-supplier-access">*/}
            {/*    <NavMenuItem icon={faShop} dest={SUPPORT_REPORTS_SUPPLIERS_ROUTE}>*/}
            {/*        Suppliers*/}
            {/*    </NavMenuItem>*/}
            {/*</LocalizedStrict>*/}
            {/*<LocalizedStrict id="support-nav-item-merchant-access">*/}
            {/*    <NavMenuItem icon={faShop} dest={SUPPORT_REPORTS_MERCHANTS_ROUTE}>*/}
            {/*        Merchants*/}
            {/*    </NavMenuItem>*/}
            {/*</LocalizedStrict>*/}
            {/* the support order endpoints are not live yet (404), so the pages stay off QA/prod */}
            <MatchEnvironment environments={UNFINISHED_FEATURE_ENVIRONMENTS}>
                <LocalizedStrict id="support-nav-item-orders-title" attrs={{ title: true }}>
                    <NavMenuItemGroupWrapper
                        icon={faBasketShopping}
                        dest={SUPPORT_REPORTS_ROUTE_ORDERS_ROUTE}
                        title="Orders"
                    >
                        <LocalizedStrict id="support-nav-item-orders-pos">
                            <NavMenuSubItem route={SUPPORT_REPORTS_ROUTE_ORDERS_POS_ROUTE}>POS</NavMenuSubItem>
                        </LocalizedStrict>
                        <LocalizedStrict id="support-nav-item-accounting-meeting-service">
                            <NavMenuSubItem route={SUPPORT_REPORTS_ROUTE_ORDERS_MEETING_SERVICE_ROUTE}>
                                Meeting service
                            </NavMenuSubItem>
                        </LocalizedStrict>
                        <LocalizedStrict id="support-nav-item-subscriptions">
                            <NavMenuSubItem route={SUPPORT_REPORTS_ROUTE_ORDERS_SUBSCRIPTIONS_ROUTE}>
                                Subscriptions
                            </NavMenuSubItem>
                        </LocalizedStrict>
                    </NavMenuItemGroupWrapper>
                </LocalizedStrict>
            </MatchEnvironment>
            {/*<LocalizedStrict id="support-nav-item-accounting-title" attrs={{ title: true }}>*/}
            {/*    <NavMenuItemGroupWrapper*/}
            {/*        icon={faFileInvoiceDollar}*/}
            {/*        dest={SUPPORT_REPORTS_ROUTE_ACCOUNTING_ROUTE}*/}
            {/*        title="Accounting"*/}
            {/*    >*/}
            {/*        */}
            {/*    </NavMenuItemGroupWrapper>*/}
            {/*</LocalizedStrict>*/}
            <LocalizedStrict id="support-nav-item-messages" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faPaperPlane} dest={SUPPORT_REPORTS_MESSAGES_ROUTE} title="Messages">
                    <LocalizedStrict id="support-nav-item-email">
                        <NavMenuSubItem route={SUPPORT_REPORTS_MESSAGES_EMAIL_ROUTE}>Email</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="support-nav-item-sms">
                        <NavMenuSubItem route={SUPPORT_REPORTS_MESSAGES_SMS_ROUTE}>SMS</NavMenuSubItem>
                    </LocalizedStrict>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
            <LocalizedStrict id="support-nav-item-printer-queue">
                <NavMenuItem icon={faPrint} dest={SUPPORT_REPORTS_PRINTER_QUEUE}>
                    Printer queue
                </NavMenuItem>
            </LocalizedStrict>
            <LocalizedStrict id="support-nav-item-devices">
                <NavMenuItem icon={faTabletScreen} dest={SUPPORT_REPORTS_ROUTE_DEVICES}>
                    Devices
                </NavMenuItem>
            </LocalizedStrict>
        </>
    )
}
